import actions from "./actions";

import { CREATE_TICKET, DELETE_ATTACHMENT, UPLOAD_ATTACHMENTS } from "./types";

import {
  loadingMutations,
  errorMutations,
  resetErrorsAndLoading,
  getter,
  setter
} from "@/store/utils";

const state = {
  isLoading: false,
  errors: null,
  createdTickets: []
};

const getters = { isLoading: getter("isLoading") };

const mutations = {
  [CREATE_TICKET.success](state, { payload }) {
    // state.createdTickets.push(payload);
    resetErrorsAndLoading(state);
  },

  [UPLOAD_ATTACHMENTS.success](state, { payload }) {
    resetErrorsAndLoading(state);
  },

  [DELETE_ATTACHMENT.success](state, { payload }) {
    resetErrorsAndLoading(state);
  },

  ...loadingMutations([
    CREATE_TICKET.request,
    UPLOAD_ATTACHMENTS.request,
    DELETE_ATTACHMENT.request
  ]),
  ...errorMutations([
    CREATE_TICKET.error,
    UPLOAD_ATTACHMENTS.error,
    DELETE_ATTACHMENT.error
  ])
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
